import {Inject, Injectable, Optional} from '@angular/core';
import {HttpClient, HttpEvent, HttpHeaders, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';

@Injectable()
export class BwGraphsVvlansService {

  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  protected basePath = 'https://localhost';

  constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  public getBwGraphsVvlans(observe?: 'body', reportProgress?: boolean): Observable<any>;
  public getBwGraphsVvlans(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
  public getBwGraphsVvlans(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
  public getBwGraphsVvlans(observe: any = 'body', reportProgress: boolean = false): Observable<any> {
    let headers = this.defaultHeaders;

    const httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    return this.httpClient.get<any>(`${this.basePath}/api/bw-graphs/vvlans`, {
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
      reportProgress: reportProgress
    });
  }
}
